<template>
  <div class="header-container">
    <div class="app-logo" @click.prevent="handleClick">
      <img :src="headLogo" alt="">
    </div>
    <div class="navbar">
      <div class="mobile-menu-trigger" @click="toggleMobileMenu" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul class="navbar-wrapper" :class="{ open: mobileMenuOpen }">
        <li v-for="item in menus" :key="item.key" class="navbar-item"
          :class="{ 'navbar-item-active': isActive === item.key }">
          <span class="navbar-item-span" @click.prevent.stop="handleMenuItem(item)">
            {{ item.label }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasToken: false,
      isActive: '',
      headLogo: require('../../assets/logo.png'),
      userInfo: {
        name: 'Cynthia',
        logo: require('../../assets/logo.png')
      },
      menus: [
        { label: '新闻资讯', key: 'shop' },
        { label: '案例中心', key: 'case' },
        { label: '公司简介', key: 'service' }
      ],
      mobileMenuOpen: false
    }
  },
  watch: {
    $route(route) {
      if (route.fullPath !== this.isActive) {
        this.isActive = ''
      }
    }
  },
  created() {
    this.isActive = this.$route.fullPath
  },
  methods: {
    handleClick() {
      this.$router.push('/')
    },
    handleMenuItem(menu) {
      document.getElementById(menu.key).scrollIntoView({ block: 'start', behavior: 'smooth' })
      if (window.innerWidth <= 768) {
        this.mobileMenuOpen = false
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    handleLogin() {
      alert(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  height: 137px;
  padding: 0 180px;
  display: flex;
  justify-content: space-between;

  .app-logo {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      height: 54px;
      margin-right: 10px;
    }

    .head-title {
      font-size: 48px;
    }
  }

  .navbar {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 24px;
    user-select: none;

    .mobile-menu-trigger {
      display: none;
      flex-direction: column;
      justify-content: space-between;
      width: 28px;
      height: 20px;
      cursor: pointer;
      margin-left: 16px;

      span {
        display: block;
        height: 2px;
        width: 100%;
        background: #2d2d2d;
        border-radius: 2px;
      }
    }

    .navbar-wrapper {
      display: flex;

      .navbar-item {
        margin-right: 100px;
        height: 137px;
        line-height: 137px;

        .navbar-item-span {
          cursor: pointer;
        }
      }

      .navbar-item-active {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 5px;
          background: #325df3;
        }
      }
    }

    .user-logo {
      display: flex;
      align-items: center;
      margin-left: 45px;
      color: #325DF3;
      position: relative;

      img {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        background-color: #aaa;
        margin-right: 10px;
      }

      .ant-dropdown-link {
        padding-right: 25px;
      }

      .ant-dropdown-link::after {
        content: "";
        position: absolute;
        top: 32px;
        right: 0px;
        width: 0;
        height: 0;
        border-top: 8px solid #325DF3;
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
      }
    }

    .login-btn {
      font-size: 26px;
      width: 178px;
      height: 74px;
      border: 5.33px solid #325df3;
      border-radius: 8px;
      color: #325df3;
    }
  }
}

@media (max-width: 1024px) {
  .header-container {
    padding: 0 32px;
  }

  .navbar {
    font-size: 20px;
  }

  .navbar-wrapper {
    flex-wrap: wrap;
  }

  .navbar-item {
    margin-right: 28px;
    height: auto;
    line-height: normal;
    padding: 10px 0;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 16px;
  }

  .app-logo {
    margin-bottom: 16px;
  }

  .navbar {
    width: 100%;
    justify-content: center;
  }

  .mobile-menu-trigger {
    display: flex;
  }

  .navbar-wrapper {
    display: none;
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: calc(100% - 32px);
    max-width: 360px;
    background: rgba(255, 255, 255, 0.98);
    flex-direction: column;
    padding: 10px 8px;
    border-radius: 20px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    z-index: 20;
  }

  .navbar-wrapper.open {
    display: flex;
  }

  .navbar-item {
    margin: 0;
    width: 100%;
    border-bottom: 1px solid rgba(45, 45, 45, 0.08);
    padding: 10px 0;
    height: auto;
    line-height: normal;
  }

  .navbar-item:last-child {
    border-bottom: none;
  }

  .navbar-item-span {
    display: block;
    width: 100%;
    font-size: 16px;
    color: #2d2d2d;
    padding: 6px 0;
  }

  .navbar-item-active::after {
    display: none;
  }

  .navbar-wrapper {
    flex-wrap: wrap;
    justify-content: center;
  }

  .navbar-item {
    margin: 0 12px 10px;
    height: auto;
    line-height: normal;
    padding: 8px 0;
  }

  .navbar-item-active::after {
    bottom: 0;
  }

  .login-btn {
    width: auto;
    padding: 8px 18px;
  }
}
</style>
